export default __webpack_public_path__ + "static/media/danone.f5be9ae6.svg";